var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"links-wrapper"},[_c('ul',{staticClass:"links-list"},_vm._l((_vm.data),function(item){return (item.unit)?_c('unit-list-item',{key:item.name,attrs:{"type":item}}):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }